'use client';

import { useMemo } from 'react';

import { UserType } from '@enums/index';

import { useMenteeSignupMutation, useMentorSignupMutation } from '../api';
import { SignUpRequest } from '../types';

interface SignupProps {
    userType: UserType;
}

export default function useSignup({ userType }: SignupProps) {
    const [mentorSignup, { isLoading: isMentorLoading }] = useMentorSignupMutation();
    const [menteeSignup, { isLoading: IsMenteeLoading }] = useMenteeSignupMutation();

    const isLoading = useMemo(
        () => isMentorLoading || IsMenteeLoading,
        [isMentorLoading, IsMenteeLoading]
    );

    const handleMentorSignup = async (payload: SignUpRequest) => {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            if (value !== null) {
                formData.append(key, value);
            }
        });
        await mentorSignup(formData).unwrap();
    };

    const handleMenteeSignup = async (payload: SignUpRequest) => {
        await menteeSignup(payload).unwrap();
    };

    const handleSignup = async (payload: SignUpRequest) => {
        switch (userType) {
            case UserType.Mentor:
                await handleMentorSignup(payload);
                break;
            case UserType.Mentee:
                await handleMenteeSignup(payload);
                break;
            default:
                break;
        }
    };
    return {
        handleSignup,
        isLoading,
    };
}
